var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenuCloseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.707137 12.0208C0.519601 11.8333 0.414244 11.5789 0.414244 11.3137C0.414244 11.0485 0.519601 10.7942 0.707137 10.6066L10.6066 0.707119C10.7942 0.519583 11.0485 0.414225 11.3137 0.414226C11.579 0.414226 11.8333 0.519583 12.0208 0.707119C12.2084 0.894656 12.3137 1.14901 12.3137 1.41423C12.3137 1.67944 12.2084 1.9338 12.0208 2.12133L2.12135 12.0208C1.93381 12.2084 1.67946 12.3137 1.41424 12.3137C1.14903 12.3137 0.894674 12.2084 0.707137 12.0208Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.707108 0.707351C0.894645 0.519815 1.149 0.414457 1.41422 0.414457C1.67943 0.414457 1.93379 0.519815 2.12132 0.707351L12.0208 10.6068C12.2084 10.7944 12.3137 11.0487 12.3137 11.314C12.3137 11.5792 12.2084 11.8335 12.0208 12.0211C11.8333 12.2086 11.5789 12.314 11.3137 12.314C11.0485 12.314 10.7941 12.2086 10.6066 12.0211L0.707108 2.12156C0.519572 1.93403 0.414215 1.67967 0.414215 1.41446C0.414215 1.14924 0.519572 0.894887 0.707108 0.707351Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuCloseDark);
export default __webpack_public_path__ + "static/media/burger__menu__close__dark.97aa3809f3333fa0ae650c33c9a18d65.svg";
export { ForwardRef as ReactComponent };